module.exports = __webpack_public_path__ + "img/sb.b2706196.png";